export default __webpack_public_path__ + "static/media/Ballroll_00153.947d82e5.png";